<template>
  <div class="intro-container">
    <!--div class="title">인생의 역점</div-->
    <!--button class="start-button" @click="start">시작하기</button-->
    <div class="copyright">
      © 2021~2025 인생의 역점.<br/>All rights reserved.
      <!--
      <br />
      리디아트리(대표:노권형) 사업자번호:437-20-01228
      <br />
      통신판매신고: 2025-용인기흥-02164
      <br />
      주소: 경기도 용인시 기흥구 동백중앙로 191, T817호
      <br />
      문의: 070-4506-9940
      -->
    </div>
  </div>
</template>

<script setup>
  import { useRouter } from 'vue-router'
  import { ref, onMounted } from 'vue' // onMounted 훅 import

  const router = useRouter()

  // 컴포넌트가 마운트될 때 (페이지 로딩 시) 실행
  onMounted(() => {
    const accessToken = localStorage.getItem('accessToken')

    setTimeout(() => {
      if (accessToken) {
        router.replace('/IChingDaily')
      } else {
        router.replace('/Welcome')
      }
    }, 1000) // ⏱ 3초 후 자동 이동
  })
</script>

<style scoped>
  .intro-container {
    position: relative;
    min-height: 100vh;
    width: var(--device-width);
    max-width: 480px;
    background-image: url('/images/houtian_trigrams.png');
    background-size: cover;
    background-position: center;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center; /* 타이틀 중앙 유지를 위해 다시 center */
    align-items: center;
    padding: 1.2rem;
    box-sizing: border-box;
    text-align: center;
    color: white;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  }

  /*
  .title {
    position: relative; 
    align-self: center; 
    margin-bottom: 10rem;
    font-size: 2em;
    font-weight: bold;
  }

  .start-button {
    position: absolute; 
    bottom: 15vh; 
    padding: 0.7rem 1.5rem;
    font-size: 1rem;
    border: none;
    border-radius: 8px;
    background-color: #4caf50;
    color: white;
    cursor: pointer;
    align-self: center
  }
  
  .start-button:hover {
    background-color: #45a049;
  }
*/
  .copyright {
    position: absolute; /* 절대 위치 사용 */
    bottom: 2vh; /* 화면 바닥에 위치 */
    color: white;
    text-shadow: none;
    font-size: 0.8em;
  }
</style>
